import { Box, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

type Props = {
  selectedRowCount: number;
  onClearSelection(): void;
};

export const InfiniteScrollingGridSelection = ({ selectedRowCount, onClearSelection }: Props) =>
  selectedRowCount > 0 ? (
    <Box py={1} display="flex" alignItems="center">
      <Typography>{selectedRowCount} row(s) selected</Typography>
      {selectedRowCount > 0 && (
        <IconButton aria-label="Clear selected rows" color="secondary" onClick={onClearSelection}>
          <Close />
        </IconButton>
      )}
    </Box>
  ) : null;
